import type { TMessages } from '@/types/TMessages'

export const messages = {
  search: 'Найти',
} satisfies TMessages
